<div class="emr-test-wrapper panel-body">
	<div class="panel panel-default panel-xs emr-test">
		<div
			class="panel-heading emr-test-heading"
			[style.background-color]="headerBackground || null"
			(click)="onHeaderClick($event)"
			[attr.data-test-id]="'dynamicTestDetailsHeader'">
			{{ title }}
		</div>
		<div class="panel-body"
			 (click)="onCanvasClick($event)"
			 [style.width.px]="width"
			 [style.height.px]="height">
			<div class="emr-test-form">
				@for (labelData of labels; track trackByLabelId; let labelIndex = $index) {
					<div class="label"
						 [id]="'label' + labelData.id"
						 (click)="onLabelClick($event, labelData)"
						 [attr.data-test-id]="'label' + labelIndex"
						 [ngStyle]="labelStyles(labelData)">
						{{ labelData.text }}
					</div>
				}
				@for (formFieldData of fields; track trackByFieldId; let fieldIndex = $index) {
					<maj-form-field
						[config]="mergedConfig(formFieldData)"
						[value]="values?.[formFieldData.id] ?? formFieldData.value ?? null"
						(valueChange)="onFieldValueChange($event, formFieldData)"
						(click)="$event.stopPropagation()"
						[isSelected]="isFieldSelected(formFieldData)"
						(fieldSelected)="onFieldSelected($event, formFieldData)"
						[attr.data-test-id]="'form-field' + fieldIndex">
					</maj-form-field>
				}
			</div>
		</div>
	</div>
</div>
